import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v33.1.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { _ as e } from "../tslib.es6.js";
import t from "@arcgis/core/layers/GraphicsLayer";
import * as s from "@arcgis/core/geometry/support/geodesicUtils";
import * as i from "@arcgis/core/geometry/support/webMercatorUtils";
import { T as a } from "../index.js";
import { L as r, c as n, T as o, C as h } from "../enums.js";
import { G as l } from "../geometry/creator.js";
import { b as c, d } from "../geometry/utils.js";
import { S as u } from "../symbols.js";
import { L as p } from "../label-manager.js";
import { e as g } from "../utils/map.js";
var m;

var MeasureTools = /*#__PURE__*/function () {
  function MeasureTools(e, s) {
    var _this = this;

    _classCallCheck(this, MeasureTools);

    m.set(this, []), this.nbrMeasureGraphics = 0, this.selectedCoordinateFormat = "", this.map = e, this.options = s;
    var i = this.map;
    this.layer = i.map.findLayerById(r.MEASURE_GRAPHICS_LAYER), this.layer || (this.layer = new t({
      id: r.MEASURE_GRAPHICS_LAYER
    }), i.map.add(this.layer)), this.update(this.options);
    var o = {
      autoPanInsets: [this.getDimensions()],
      drawLayer: this.layer,
      persistGraphics: !0
    };
    this.polygonCreator = new l(this.map, _objectSpread(_objectSpread({}, o), {}, {
      geometryType: n.POLYGON,
      invalidSymbol: u.fromJSON(a.symbols.measure.area.invalid),
      onDraw: function onDraw(e) {
        return _this._onDraw(n.POLYGON, e);
      },
      symbol: u.fromJSON(a.symbols.measure.area.fill),
      onNbrGraphicsChanged: function onNbrGraphicsChanged(e) {
        return _this._onNbrGraphicsChanged(e);
      }
    })), this.polylineCreator = new l(this.map, _objectSpread(_objectSpread({}, o), {}, {
      geometryType: n.POLYLINE,
      onDraw: function onDraw(e) {
        return _this._onDraw(n.POLYLINE, e);
      },
      symbol: u.fromJSON(a.symbols.measure.length.line),
      onNbrGraphicsChanged: function onNbrGraphicsChanged(e) {
        return _this._onNbrGraphicsChanged(e);
      },
      nudgeOptions: {
        enabled: !0
      }
    })), this.pointCreator = new l(this.map, _objectSpread(_objectSpread({}, o), {}, {
      geometryType: n.POINT,
      onDraw: function onDraw(e) {
        return _this._onDraw(n.POINT, e);
      },
      symbol: u.fromJSON(a.symbols.measure.location.marker),
      onNbrGraphicsChanged: function onNbrGraphicsChanged(e) {
        return _this._onNbrGraphicsChanged(e);
      }
    }));
  }

  _createClass(MeasureTools, [{
    key: "_calculateArea",
    value: function _calculateArea(e) {
      var t = c.calculateArea(e, this._getSelectedOption(this.selectedAreaUnit, this.areaUnits).esriUnit);
      return "NaN" === t && (t = "0.00"), t;
    }
  }, {
    key: "_calculateLength",
    value: function _calculateLength(e) {
      return d(Math.abs(s.geodesicLengths([i.webMercatorToGeographic(e)], this._getSelectedOption(this.selectedLengthUnit, this.lengthUnits).esriUnit)[0]));
    }
  }, {
    key: "_calculateLocation",
    value: function _calculateLocation(e) {
      var t = e.spatialReference.isWebMercator ? i.webMercatorToGeographic(e) : e;
      if (!t) return "";

      switch (this._getSelectedOption(this.selectedCoordinateFormat, this.coordinateFormat)) {
        case g.DECIMAL_DEGREES:
          return "".concat(t.y.toFixed(4), ", ").concat(t.x.toFixed(4));

        case g.DEGREE_MINUTE_SECONDS:
          {
            var _e = t.y >= 0 ? "N" : "S",
                _s = t.x >= 0 ? "E" : "W",
                _i = Math.floor(Math.abs(t.x)),
                _a = Math.floor(Math.abs(t.y)),
                _r = 60 * Math.abs(Math.abs(t.x) - _i),
                _n = 60 * Math.abs(Math.abs(t.y) - _a),
                _o = Math.floor(_r),
                _h = Math.floor(_n),
                _l = Math.round(60 * (_r - _o));

            return "".concat(_a, "\xB0").concat(_h, "'").concat(Math.round(60 * (_n - _h)), "\"").concat(_e, " ").concat(_i, "\xB0").concat(_o, "'").concat(_l, "\"").concat(_s);
          }

        default:
          return "".concat(t.y.toFixed(4), ", ").concat(t.x.toFixed(4));
      }
    }
  }, {
    key: "_clearMeasurements",
    value: function _clearMeasurements() {
      this.selectTab(this.selectedTab, !0), this.clearMeasurementGraphics();
    }
  }, {
    key: "_forceUpdate",
    value: function _forceUpdate() {
      this.options.forceUpdate && this.options.forceUpdate();
    }
  }, {
    key: "_getAreaUnitEquivalent",
    value: function _getAreaUnitEquivalent(e) {
      var t = e.toUpperCase();

      switch (!0) {
        case t.indexOf("ACRE") >= 0:
          return "acres";

        case t.indexOf("KILOMETER") >= 0:
          return "square-kilometers";

        case t.indexOf("DECIMETER") >= 0:
          return 109450;

        case t.indexOf("CENTIMETER") >= 0:
          return 109451;

        case t.indexOf("MILLIMETER") >= 0:
          return 109452;

        case t.indexOf("METER") >= 0:
          return "square-meters";

        case t.indexOf("STATUTE") >= 0:
          return 109439;

        case t.indexOf("NAUTICAL") >= 0:
          return 109409;

        case t.indexOf("MILE") >= 0:
          return "square-miles";

        case t.indexOf("YARD") >= 0:
          return "square-yards";

        case t.indexOf("FOOT") >= 0:
        case t.indexOf("FEET") >= 0:
          return "square-feet";

        case t.indexOf("HECTARE") >= 0:
          return "hectares";

        case t.indexOf("ARE") >= 0:
          return "ares";

        default:
          return g.UNKNOWN;
      }
    }
  }, {
    key: "_getLengthUnitEquivalent",
    value: function _getLengthUnitEquivalent(e) {
      var t = e.toUpperCase();

      switch (!0) {
        case t.indexOf("KILOMETER") >= 0:
          return g.KILOMETERS;

        case t.indexOf("DECIMETER") >= 0:
          return g.DECIMETERS;

        case t.indexOf("CENTIMETER") >= 0:
          return g.CENTIMETERS;

        case t.indexOf("MILLIMETER") >= 0:
          return g.MILLIMETERS;

        case t.indexOf("METER") >= 0:
          return g.METERS;

        case t.indexOf("NAUTICAL") >= 0:
          return g.NAUTICAL_MILES;

        case t.indexOf("MILE") >= 0:
          return g.MILES;

        case t.indexOf("YARD") >= 0:
          return g.YARDS;

        case t.indexOf("FOOT") >= 0:
        case t.indexOf("FEET") >= 0:
          return g.FEET;

        case t.indexOf("INCH") >= 0:
          return g.INCHES;

        default:
          return g.UNKNOWN;
      }
    }
  }, {
    key: "_getSelectedOption",
    value: function _getSelectedOption(e, t) {
      return t.find(function (t) {
        return t.value === e;
      }).value;
    }
  }, {
    key: "geometries",
    get: function get() {
      return _toConsumableArray(e(this, m, "f"));
    }
  }, {
    key: "_onDraw",
    value: function _onDraw(t, _ref, a) {
      var s = _ref.finished,
          i = _ref.geometry;
      var r;

      switch (a || s || !this.finished || (this.finished = !1), t) {
        case n.POINT:
          this.coordinate = "".concat(this._calculateLocation(i)), (s || a) && (this.location = i, r = new p(this.layer), r.updateLabel(this.location, this.coordinate));
          break;

        case n.POLYGON:
          if (this.polygon = i, this.area = "".concat(this._calculateArea(this.polygon), " ").concat(this._getSelectedOption(this.selectedAreaUnit, this.areaUnits).name), this.polygon && this.polygon.rings[0].length > 2 && s) {
            var _e2 = this.polygon.extent.center;
            r = new p(this.layer), r.updateLabel(_e2, this.area);
          }

          break;

        case n.POLYLINE:
          if (this.polyline = i, this.length = "".concat(this._calculateLength(this.polyline), " ").concat(this._getSelectedOption(this.selectedLengthUnit, this.lengthUnits).name), this.polyline && this.polyline.paths[0].length > 1 && s) {
            var _e3 = this.polyline.extent.center;
            r = new p(this.layer), r.updateLabel(_e3, this.length);
          }

      }

      a || (this.finished = s), this.finished && e(this, m, "f").push(i), this._forceUpdate();
    }
  }, {
    key: "_onNbrGraphicsChanged",
    value: function _onNbrGraphicsChanged(_ref2) {
      var e = _ref2.count;
      this.nbrMeasureGraphics += e;
    }
  }, {
    key: "_updateAreaUnits",
    value: function _updateAreaUnits(e) {
      this.selectedAreaUnit = e, this.polygon && this._onDraw(n.POLYGON, {
        finished: !1,
        geometry: this.polygon
      }, !0);
    }
  }, {
    key: "_updateCoordinateFormat",
    value: function _updateCoordinateFormat(e) {
      this.selectedCoordinateFormat = e, this.location && this._onDraw(n.POINT, {
        finished: !1,
        geometry: this.location
      }, !0);
    }
  }, {
    key: "_updateLengthUnits",
    value: function _updateLengthUnits(e) {
      this.selectedLengthUnit = e, this.polylineCreator.setCurrentLengthUnit(e.esriUnit), this.polyline && this._onDraw(n.POLYLINE, {
        finished: !1,
        geometry: this.polyline
      }, !0);
    }
  }, {
    key: "activate",
    value: function activate() {
      this.selectTab(this.selectedTab || 0);
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      return {
        top: 0,
        left: 70,
        leftAndRight: !0,
        width: 320,
        height: 97
      };
    }
  }, {
    key: "getTools",
    value: function getTools() {
      return [o.MeasureArea, o.MeasureLength, o.MeasureLocation];
    }
  }, {
    key: "reset",
    value: function reset() {
      var _this2 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return new Promise(function (t) {
        _this2.polygon = null, _this2.polyline = null, _this2.location = null, _this2.area = "", _this2.length = "", _this2.coordinate = "";
        var s = [];
        s.push(_this2.polygonCreator.deactivate()), s.push(_this2.polylineCreator.deactivate()), s.push(_this2.pointCreator.deactivate()), Promise.all(s).then(function () {
          e && [o.MeasureArea, o.MeasureLength, o.MeasureLocation].includes(_this2.activeMapTool) && (_this2.options.onSetActiveMapTool(null), _this2.map.container.style.cursor = h.default), t();
        });
      });
    }
  }, {
    key: "clearMeasurementGraphics",
    value: function clearMeasurementGraphics() {
      e(this, m, "f").length = 0, this.layer.removeAll(), this.nbrMeasureGraphics = 0;
    }
  }, {
    key: "selectTab",
    value: function selectTab(e) {
      var _this3 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      this.selectedTab = e, this.reset().then(function () {
        var s;

        switch (e) {
          case 0:
            s = o.MeasureArea, _this3.polygonCreator.activate();
            break;

          case 1:
            s = o.MeasureLength, _this3.polylineCreator.activate();
            break;

          case 2:
            s = o.MeasureLocation, _this3.pointCreator.activate();
        }

        !t && s && (_this3.options.onSetActiveMapTool(s), _this3.map.map.reorder(_this3.layer, _this3.map.map.layers.length), _this3.map.container.style.cursor = h.crosshair), _this3._forceUpdate();
      });
    }
  }, {
    key: "setActiveMapTool",
    value: function setActiveMapTool(e) {
      this.activeMapTool = e;
    }
  }, {
    key: "toggle",
    value: function toggle(e) {
      e.expanded || this.reset(!0);
    }
  }, {
    key: "_setDefaultValue",
    value: function _setDefaultValue() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var s = e.find(function (e) {
        return (t || e.value.id) && e.selected;
      });
      return s ? s.value : "";
    }
  }, {
    key: "_getDefaultUnits",
    value: function _getDefaultUnits() {
      this.selectedAreaUnit || (this.selectedAreaUnit = this._setDefaultValue(this.areaUnits)), this.selectedLengthUnit || (this.selectedLengthUnit = this._setDefaultValue(this.lengthUnits)), this.selectedCoordinateFormat || (this.selectedCoordinateFormat = this._setDefaultValue(this.coordinateFormat, !0));
    }
  }, {
    key: "update",
    value: function update(e) {
      var _this4 = this;

      var _this$options = this.options,
          t = _this$options.messages,
          s = _this$options.formatMessage;
      this.areaUnits = [], this.lengthUnits = [], e.areaUnits.forEach(function (e) {
        _this4.areaUnits.push({
          value: Object.assign(e, {
            esriUnit: _this4._getAreaUnitEquivalent(e.fullName)
          }),
          label: e.fullName,
          selected: 0 === _this4.areaUnits.length
        });
      }), e.lengthUnits.forEach(function (e) {
        _this4.lengthUnits.push({
          value: Object.assign(e, {
            esriUnit: _this4._getLengthUnitEquivalent(e.fullName)
          }),
          label: e.fullName,
          selected: 0 === _this4.lengthUnits.length
        });
      }), this.coordinateFormat = [{
        value: g.DECIMAL_DEGREES,
        label: s(t.degreesOption),
        selected: !0
      }, {
        value: g.DEGREE_MINUTE_SECONDS,
        label: s(t.degreesMinutesSecondsOption),
        selected: !1
      }], this._getDefaultUnits();
    }
  }]);

  return MeasureTools;
}();

m = new WeakMap();
export { MeasureTools as M };